<template>
  <div class="card" :id="'cardGr' + indx">
    <div class="card-header" :id="'heading' + indx">
      <h5 class="mb-0">
        <button
          class="btn btn-link"
          data-toggle="collapse"
          :data-target="'#collapse' + indx"
          aria-expanded="true"
          :aria-controls="'collapse' + indx"
        >
          Grupa gr{{ indx }}
          <button :data-group="'gr' + indx" type="button" class="btn btn-danger float-right" @click="removeGroup">
            <font-awesome-icon :icon="['fas', 'minus-circle']"></font-awesome-icon>
          </button>
        </button>
      </h5>
    </div>
    <div :id="'collapse' + indx" class="collapse" :aria-labelledby="'heading' + indx" data-parent="#accordionGroups">
      <div class="card-body">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link active"
              id="gr-pos-tab"
              data-toggle="tab"
              :href="'#gr-' + indx + '-pos'"
              role="tab"
              aria-controls="gr-pos"
              aria-selected="true"
            >
              Układ
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              id="gr-bgr-tab"
              data-toggle="tab"
              :href="'#gr-' + indx + '-bgr'"
              role="tab"
              aria-controls="gr-bgr"
              aria-selected="false"
            >
              Tło
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              id="gr-itemsConfig-tab"
              data-toggle="tab"
              :href="'#gr-' + indx + '-itemsConfig'"
              role="tab"
              aria-controls="gr-itemsConfig"
              aria-selected="false"
            >
              itemsConfig
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              id="gr-items-tab"
              data-toggle="tab"
              :href="'#gr-' + indx + '-items'"
              role="tab"
              aria-controls="gr-items"
              aria-selected="false"
            >
              Items
            </a>
          </li>
        </ul>
        <div class="tab-content">
          <div
            class="tab-pane fade show active"
            :id="'gr-' + indx + '-pos'"
            role="tabpanel"
            aria-labelledby="gr-pos-tab"
          >
            <div class="custom-control custom-switch">
              <input
                class="custom-control-input autoFit"
                type="checkbox"
                :id="'autoFit' + indx"
                v-model="group.positions.autoFit"
                @change="autoFitGroup($event)"
              />
              <label class="custom-control-label" :for="'autoFit' + indx"> Autodopasowanie (autoFit) </label>
            </div>
            <div class="custom-control custom-switch">
              <input
                class="custom-control-input typePos"
                type="checkbox"
                :id="'type' + indx"
                v-model="absolute"
                @change="typeGroup($event)"
              />
              <label class="custom-control-label" :for="'type' + indx"> Położenie absolutne </label>
            </div>
            <hr />
            <div class="row d-flex align-items-center">
              <div class="col-sm">
                <input
                  type="number"
                  class="form-control"
                  :id="'gr' + indx + '-h'"
                  :disabled="group.positions.autoFit"
                  v-model.number="group.positions.pos.height"
                />
              </div>
            </div>
            <div class="row d-flex align-items-center">
              <div class="col-sm">Szerokość</div>
              <div class="col-sm">
                <input
                  type="number"
                  class="form-control"
                  :id="'gr' + indx + '-w'"
                  :disabled="group.positions.autoFit"
                  v-model.number="group.positions.pos.width"
                />
              </div>
            </div>
            <hr />
            <div class="row d-flex align-items-center">
              <div class="col-sm">Położenie X</div>
              <div class="col-sm">
                <input
                  v-if="typeof stage == 'object' && stage != null"
                  type="number"
                  class="form-control"
                  :id="'gr' + indx + '-x'"
                  v-model.number="group.positions.pos.x"
                  :disabled="!absolute"
                  @change="updateGroupCJS($event)"
                />
              </div>
            </div>
            <div class="row d-flex align-items-center">
              <div class="col-sm">Położenie Y</div>
              <div class="col-sm">
                <input
                  v-if="typeof stage == 'object' && stage != null"
                  type="number"
                  class="form-control"
                  :id="'gr' + indx + '-y'"
                  v-model.number="group.positions.pos.y"
                  :disabled="!absolute"
                  @change="updateGroupCJS($event)"
                />
              </div>
            </div>
          </div>
          <div class="tab-pane fade" :id="'gr-' + indx + '-bgr'" role="tabpanel" aria-labelledby="gr-bgr-tab">
            <div class="custom-control custom-switch">
              <input
                class="custom-control-input transparentBgr"
                :id="'gr' + indx + '-transparentBgr'"
                type="checkbox"
                @change="checkBackground($event)"
              />
              <label class="custom-control-label" :for="'gr' + indx + '-transparentBgr'"> Przezroczyste tło </label>
            </div>
            <div class="col-sm">
              <div class="itemColor input-group" title="Wybierz kolor">
                <input type="text" class="form-control input-lg grBgrColor" :id="'gr' + indx + '-colorBgr'" />
                <span class="input-group-append">
                  <span class="input-group-text colorpicker-input-addon"><i></i></span>
                </span>
              </div>
            </div>
            <hr />
            <div class="row d-flex align-items-center">
              <div class="input-group">
                <div class="custom-file">
                  <input
                    type="file"
                    class="custom-file-input"
                    :id="'gr' + indx + '-imgBgr'"
                    @change="loadBgrGroup($event)"
                  />
                  <label class="custom-file-label" :for="'gr' + indx + '-imgBgr'" data-label="plik...">plik...</label>
                </div>
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button" @click="loadBgrGroupCJS($event)">
                    Load CJS
                  </button>
                  <button class="btn btn-outline-danger" type="button" @click="removeBgrGroupCJS($event)">
                    <font-awesome-icon :icon="['fas', 'minus-circle']"></font-awesome-icon>
                  </button>
                </div>
              </div>
            </div>
            <div class="row d-flex align-items-center">
              <div class="col-sm" v-if="loadImgBgr == true">
                <div class="row d-flex align-items-center">
                  <div class="col-xs-3">Wys.</div>
                  <div class="col-sm">
                    <input
                      type="number"
                      class="form-control"
                      :id="'gr' + indx + '-bgrH'"
                      v-model.number="group.background.image.pos.height"
                      @change="updateImage($event)"
                    />
                  </div>
                </div>
                <div class="row d-flex align-items-center">
                  <div class="col-xs-3">Szer.</div>
                  <div class="col-sm">
                    <input
                      type="number"
                      class="form-control"
                      :id="'gr' + indx + '-bgrW'"
                      v-model.number="group.background.image.pos.width"
                      @change="updateImage($event)"
                    />
                  </div>
                </div>
                <div class="row d-flex align-items-center">
                  <div class="col-xs-3">Poł.X</div>
                  <div class="col-sm">
                    <input
                      type="number"
                      class="form-control"
                      :id="'gr' + indx + '-bgrH'"
                      v-model.number="group.background.image.pos.x"
                      @change="updateImage($event)"
                    />
                  </div>
                </div>
                <div class="row d-flex align-items-center">
                  <div class="col-xs-3">Poł.Y</div>
                  <div class="col-sm">
                    <input
                      type="number"
                      class="form-control"
                      :id="'gr' + indx + '-bgrH'"
                      v-model.number="group.background.image.pos.y"
                      @change="updateImage($event)"
                    />
                  </div>
                </div>
              </div>
              <div class="col-sm">
                <img :id="'gr' + indx + '-prevImgBgr'" class="img-fluid img-thumbnail mx-auto prevImgBgr" />
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            :id="'gr-' + indx + '-itemsConfig'"
            role="tabpanel"
            aria-labelledby="gr-itemsConfig-tab"
          >
            <div class="accordion" :id="'gr' + indx + '-accordionItemsConfig'">
              <div class="card">
                <div class="card-header" :id="'gr' + indx + '-headingIC-pos'">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link"
                      type="button"
                      data-toggle="collapse"
                      :data-target="'#gr' + indx + 'collapseIC-pos'"
                      aria-expanded="true"
                      :aria-controls="'gr' + indx + 'collapseIC-pos'"
                    >
                      Układ
                    </button>
                  </h2>
                </div>
                <div
                  :id="'gr' + indx + 'collapseIC-pos'"
                  class="collapse show"
                  :aria-labelledby="'gr' + indx + '-headingIC-pos'"
                  :data-parent="'#gr' + indx + '-accordionItemsConfig'"
                >
                  <div class="card-body">
                    <div class="row d-flex align-items-center">
                      <div class="col-sm">Wysokość</div>
                      <div class="col-sm">
                        <input
                          type="number"
                          class="form-control"
                          :id="'gr' + indx + '-ICh'"
                          v-model.number="group.itemsConfig.positions.pos.height"
                        />
                      </div>
                    </div>
                    <div class="row d-flex align-items-center">
                      <div class="col-sm">Szerokość</div>
                      <div class="col-sm">
                        <input
                          type="number"
                          class="form-control"
                          :id="'gr' + indx + '-ICw'"
                          v-model.number="group.itemsConfig.positions.pos.width"
                        />
                      </div>
                    </div>
                    <hr />
                    <div class="row d-flex align-items-center">
                      <div class="col-sm">Położenie X</div>
                      <div class="col-sm">
                        <input
                          type="number"
                          class="form-control"
                          :id="'gr' + indx + '-ICx'"
                          v-model.number="group.itemsConfig.positions.pos.x"
                        />
                      </div>
                    </div>
                    <div class="row d-flex align-items-center">
                      <div class="col-sm">Położenie Y</div>
                      <div class="col-sm">
                        <input
                          type="number"
                          class="form-control"
                          :id="'gr' + indx + '-ICy'"
                          v-model.number="group.itemsConfig.positions.pos.y"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" :id="'gr' + indx + '-headingIC-bgr'">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link"
                      type="button"
                      data-toggle="collapse"
                      :data-target="'#gr' + indx + 'collapseIC-bgr'"
                      aria-expanded="true"
                      :aria-controls="'gr' + indx + 'collapseIC-bgr'"
                    >
                      Tło
                    </button>
                  </h2>
                </div>
                <div
                  :id="'gr' + indx + 'collapseIC-bgr'"
                  class="collapse"
                  :aria-labelledby="'gr' + indx + '-headingIC-bgr'"
                  :data-parent="'#gr' + indx + '-accordionItemsConfig'"
                >
                  <div class="card-body">Tło</div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" :id="'gr-' + indx + '-items'" role="tabpanel" aria-labelledby="gr-items-tab">
            <button class="btn btn-primary" type="button" @click="addItem($event)">
              <font-awesome-icon :icon="['fas', 'plus-circle']"></font-awesome-icon>
              Dodaj element
            </button>
            <div class="scrollbar scrollbar-primary">
              <div class="force-overflow">
                <div class="accordion" :id="'gr' + indx + '-accordionItems'">
                  <mp-item-cjs
                    v-for="item in group.items"
                    :key="item.id"
                    :item="item"
                    :stage="stage"
                    :id-group="group.idGroup"
                    @changeConfig="onUpdateGame"
                  ></mp-item-cjs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import * as $ from 'jquery';
import 'bootstrap';
import 'bootstrap-colorpicker';
import createjs from 'createjs-collection';

import MpItemCJS from './MpItemCJS';

import { BaseEngine } from '../js/baseEngine.js';

export default {
  name: 'mp-group-cjs',
  components: { 'mp-item-cjs': MpItemCJS },
  props: {
    group: {
      type: Object,
      default: function () {
        return new BaseEngine();
      },
    },
    stage: {
      type: Object,
      default: function () {},
    },
  },
  data: function () {
    return {
      indx: -1,
      loadImgBgr: false,
      next: 0,
      absolute: true,
    };
  },
  mounted() {
    this.indx = this.group.idGroup.match(/\d+$/).join('');
    this.init();
  },

  methods: {
    typeGroup(e) {
      console.log('TYPE');
      this.absolute != this.absolute;
      if (this.absolute == true) {
        this.group.positions.type = 'absolute';
      } else {
        delete this.group.positions.type;
        this.group.positions.pos.x = null;
        this.group.positions.pos.y = null;
      }
      // this.$emit('changeConfig', this.group);
    },
    onUpdateGame(item) {
      if (item.delete === true) {
        this.group.removeItem(item.id);
      } else {
        this.group.updateItem(item.id);
      }
      this.$emit('changeConfig', this.group);
    },
    init() {
      let self = this;

      $(document).on('change', '#cardGr' + this.indx + ' input', function () {
        if ($(this).hasClass('grBgrColor')) {
          self.group.background.color = $(this).val();
        }

        self.$emit('changeConfig', self.group);
      });

      $('.itemColor').colorpicker({ format: 'rgba', color: this.group.background.color });
    },
    addItem(e) {
      // this.gameJS.addItem(this.group.idGroup, 's' + this.next);
      console.log(this.group);
      this.group.items.push({ id: 's' + this.next });
      this.next++;
      this.$emit('changeConfig', this.group);
    },
    removeGroup(e) {
      this.$emit('changeConfig', { delete: true, idGroup: this.group.idGroup });
    },
    checkBackground(e) {
      if ($(e.target).prop('checked')) {
        this.group.background.color = 'transparent';
        $('#gr' + this.indx + '-colorBgr').val('');
      } else {
        this.group.background.color = 'rgba(255,255,255,0)';
        $('#gr' + this.indx + '-colorBgr').val(this.group.background.color);
      }

      $('#gr' + this.indx + '-colorBgr').prop('disabled', $(e.target).prop('checked'));
    },
    updateGroupCJS(e) {
      this.stage.groups[this.group.idGroup].x = this.group.positions.pos.x;
      this.stage.groups[this.group.idGroup].y = this.group.positions.pos.y;
      this.stage.groups[this.group.idGroup].pos.x = this.stage.groups[this.group.idGroup].posStart.x;
      this.stage.groups[this.group.idGroup].pos.y = this.stage.groups[this.group.idGroup].posStart.y;
    },
    loadBgrGroup(e) {
      if ($('#gr' + this.indx + '-imgBgr').val().length == 0) {
        return;
      }
      let reader = new FileReader(),
        self = this;
      reader.onload = function () {
        let preview = document.getElementById('gr' + self.indx + '-prevImgBgr');
        preview.src = reader.result;
      };
      reader.readAsDataURL(e.target.files[0]);
    },
    loadBgrGroupCJS(e) {
      if (!$('#gr' + this.indx + '-imgBgr').val()) {
        return;
      }
      if (typeof this.group.background.image == 'undefined' || this.group.background.image == null) {
        this.group.background.image = {
          pos: { x: 0, y: 0, width: this.group.positions.pos.width, height: this.group.positions.pos.height },
        };
      }

      this.group.background.image.src =
        'dirPath + /img/' +
        $('#gr' + this.indx + '-imgBgr')
          .val()
          .split('\\')
          .pop();

      this.stage.addImageBgr(
        document.getElementById('gr' + this.indx + '-prevImgBgr'),
        this.stage.groups[this.group.idGroup].container,
        this.group.background.image
      );

      this.loadImgBgr = true;
    },
    removeBgrGroupCJS(e) {
      if (this.loadImgBgr != true) return;
      this.loadImgBgr = false;
      document.getElementById('gr' + this.indx + '-prevImgBgr').removeAttribute('src');
      delete this.group.background.image;
      this.stage.removeImageBgr(this.stage.groups[this.group.idGroup].container);
      $('#gr' + this.indx + '-imgBgr').val('');
      let label = $('#gr' + this.indx + '-imgBgr')
        .closest('div')
        .find('label');

      $(label).html($(label).data('label'));
    },
    updateImage(e) {
      // group.background.image.pos.y
      if (this.group.background.image.pos.x + this.group.background.image.pos.width > this.group.positions.pos.width) {
        this.group.positions.pos.width = this.group.background.image.pos.x + this.group.background.image.pos.width;
      }
      if (
        this.group.background.image.pos.y + this.group.background.image.pos.height >
        this.group.positions.pos.height
      ) {
        this.group.positions.pos.height = this.group.background.image.pos.y + this.group.background.image.pos.height;
      }
      this.stage.updateImageBgr(this.stage.groups[this.group.idGroup].container, this.group.background.image.pos);

      this.$emit('changeConfig', this.group);
    },
    autoFitGroup(e) {
      if (this.group.positions.autoFit == true) {
        this.group.positions.pos.width = null;
        this.group.positions.pos.height = null;
      }

      this.$emit('changeConfig', this.group);
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {},
};
</script>
<style lang="sass">
.card-header
  padding: 0.25rem 0.5rem
</style>
<style lang="sass" scoped>
.mb-0, .mb-0 > button:first-child
    width: 100%

.tab-pane
  padding-top: 20px

.prevImgBgr
  width: 100px
  height: 100px
  margin-top: 10px

.scrollbar
  max-height: 350px
  background: #fff
  overflow-y: scroll
  margin-bottom: 25px
  padding-right: 10px

.scrollbar-primary::-webkit-scrollbar
  width: 12px
  background-color: #F5F5F5

.scrollbar-primary::-webkit-scrollbar-thumb
  border-radius: 10px
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1)
  background-color: #4285F4

.scrollbar-primary
  scrollbar-color: #4285F4 #F5F5F5
</style>
